import { render, staticRenderFns } from "./template-card.vue?vue&type=template&id=4f7fb853&"
import script from "./template-card.vue?vue&type=script&lang=js&"
export * from "./template-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports